import { DashboardSdk } from '@bringg/frontend-utils';
import { Task } from '@bringg/types';
import axios from 'axios';

import { getCreateTaskServiceUrl } from 'Services';
import { sleep } from '../helpers';

const waitForFleetAssignment = async (taskId: number, dashboardSDK: DashboardSdk): Promise<Task> => {
  let task: Task | null = null;

  while (!task || !task.fleet_delivery_external_id) {
    await sleep(300);
    task = await dashboardSDK.sdk.tasks.forceGet(taskId);
  }

  return task;
};

export const saveTask = async (task: Task): Promise<Task> => {
  const resp = (await axios.post((await getCreateTaskServiceUrl()) as string, task)).data;

  if (!resp.success) {
    throw new Error(resp.message);
  }

  return resp.task;
};

export const saveTaskAndWaitForFleetAssignment = async (task: Task, dashboardSDK: DashboardSdk) => {
  const respTask = await saveTask(task);

  return waitForFleetAssignment(respTask.id as number, dashboardSDK);
};
